// extracted by mini-css-extract-plugin
module.exports = {"leaderboardContainer":"ChallengeLeaderboard_leaderboardContainer__pmb4e"};